import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { foodGallery, mobileGallery } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center mv="30px">
          <CFImage src={mobileGallery} w="90%" alt="Food Gallery" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center m="50px auto" w="100%">
          <CFImage src={foodGallery} alt="Food Gallery" w="80%" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
